"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Details = Details;
exports.Footer = Footer;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _ShareButton = _interopRequireDefault(require("../ResourceLists/ShareButton"));
var _index = _interopRequireDefault(require("../ResourceLists/FavoriteButton/index.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _clock = _interopRequireDefault(require("cccisd-icons/clock"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
var _minusCircle = _interopRequireDefault(require("cccisd-icons/minus-circle"));
var _clipboard = _interopRequireDefault(require("cccisd-icons/clipboard2"));
var _earth = _interopRequireDefault(require("cccisd-icons/earth"));
var _user = _interopRequireDefault(require("cccisd-icons/user3"));
var _newTab = _interopRequireDefault(require("cccisd-icons/new-tab"));
var _icons = require("./icons.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } // Icons
function Details(_ref) {
  var resource = _ref.resource,
    displayOptions = _ref.displayOptions;
  var metadata = JSON.parse(resource.published_metadata) || {};
  var getFlowLanguages = function getFlowLanguages() {
    var languages = new Set();
    if (metadata.surveyInfo && metadata.surveyInfo.flowList) {
      metadata.surveyInfo.flowList.forEach(function (flow) {
        if (flow.language === 'en') {
          flow.language = 'English';
        }
        if (flow.language === 'es') {
          flow.language = 'Spanish';
        }
        languages.add(flow.language);
      });
    }
    return _toConsumableArray(languages).join(', ');
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].descriptors,
    style: {
      color: displayOptions.descriptionTextColor
    }
  }, metadata.duration && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.shareButtonColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_clock["default"], {
    spaceRight: true
  }), " ", /*#__PURE__*/_react["default"].createElement("span", null, metadata.duration || '15 minutes')), metadata.surveyType && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.shareButtonColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_clipboard["default"], {
    spaceRight: true
  }), " ", /*#__PURE__*/_react["default"].createElement("span", null, metadata.surveyType || 'Survey')), metadata.audience && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.shareButtonColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_user["default"], {
    spaceRight: true
  }), " ", /*#__PURE__*/_react["default"].createElement("span", null, metadata.audience)), metadata.showLanguage && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.shareButtonColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_earth["default"], {
    spaceRight: true
  }), " ", /*#__PURE__*/_react["default"].createElement("span", null, getFlowLanguages()))), displayOptions.showDescription && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: displayOptions.descriptionTextColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: resource.published_description || ''
  })));
}
function Tags(_ref2) {
  var resource = _ref2.resource;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].tags
  }, resource.tags && Object.keys(resource.tags).map(function (tag, j) {
    if (Object.keys(resource.tags).length === j + 1) {
      return resource.tags[tag];
    }
    return resource.tags[tag] + ', ';
  }));
}
function Actions(_ref3) {
  var metadata = _ref3.metadata,
    resource = _ref3.resource,
    displayOptions = _ref3.displayOptions,
    externalShareUrl = _ref3.externalShareUrl,
    collection = _ref3.collection,
    addToCollection = _ref3.addToCollection,
    removeFromCollection = _ref3.removeFromCollection,
    _ref3$addToCollection = _ref3.addToCollectionButtonLabel,
    addToCollectionButtonLabel = _ref3$addToCollection === void 0 ? 'Add to Collection' : _ref3$addToCollection,
    useFavorite = _ref3.useFavorite;
  var btnDataArray = {
    visitWebsite: {
      "class": _style["default"].buttonVisitWebsite,
      icon: _newTab["default"],
      label: 'Visit Website',
      href: metadata.link
    },
    collection: {
      "class": _style["default"].buttonCollection,
      icon: _plusCircle["default"],
      label: addToCollectionButtonLabel,
      href: metadata.link
    }
  };
  var btnKey = 'collection';
  if (metadata.isExternal) {
    btnKey = 'visitWebsite';
  }
  var btnData = btnDataArray[btnKey];
  var ButtonIcon = btnData.icon;
  var LearnMoreButton = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, metadata.infoResource && /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn ".concat(_style["default"].buttonLearnMore),
    href: metadata.infoResource.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn More"));
  var renderAddRemoveButtons = function renderAddRemoveButtons() {
    if (collection) {
      var collectionItem = collection.find(function (i) {
        return i.id === resource.id;
      });
      if (collectionItem) {
        if (collectionItem.progress && collectionItem.progress.end) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-danger",
          onClick: function onClick() {
            return removeFromCollection(resource.id);
          }
        }, "Remove", /*#__PURE__*/_react["default"].createElement(_minusCircle["default"], {
          spaceLeft: true
        }));
      }
      var getFlowLanguages = function getFlowLanguages() {
        var languages = new Set();
        if (metadata.surveyInfo && metadata.surveyInfo.flowList) {
          metadata.surveyInfo.flowList.forEach(function (flow) {
            languages.add(flow.language);
          });
        }
        return _toConsumableArray(languages);
      };
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn ".concat(btnData["class"]),
        onClick: function onClick() {
          var item = {
            id: resource.id,
            label: resource.published_label,
            description: resource.published_description,
            tags: resource.tags,
            languages: getFlowLanguages(),
            resource: resource
          };
          addToCollection(item);
        }
      }, addToCollectionButtonLabel, /*#__PURE__*/_react["default"].createElement(ButtonIcon, {
        spaceLeft: true
      }));
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].actions
  }, renderAddRemoveButtons(), LearnMoreButton, (displayOptions.showShareButton || displayOptions.showFavoriteIcon) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonShare
  }, displayOptions.showFavoriteIcon && /*#__PURE__*/_react["default"].createElement(_index["default"], {
    resource: resource,
    useFavorite: useFavorite,
    color: displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.favoriteButtonColor
  }), displayOptions.showShareButton && /*#__PURE__*/_react["default"].createElement(_ShareButton["default"], {
    name: resource.published_label,
    url: externalShareUrl,
    displayOptions: displayOptions
  })));
}
function Footer(_ref4) {
  var resource = _ref4.resource,
    displayOptions = _ref4.displayOptions,
    externalShareUrl = _ref4.externalShareUrl,
    collection = _ref4.collection,
    addToCollection = _ref4.addToCollection,
    removeFromCollection = _ref4.removeFromCollection,
    addToCollectionButtonLabel = _ref4.addToCollectionButtonLabel,
    useFavorite = _ref4.useFavorite;
  var metadata = JSON.parse(resource.published_metadata) || {};
  var renderProgress = function renderProgress() {
    if (collection) {
      var collectionItem = collection.find(function (i) {
        return i.id === resource.id;
      });
      if (collectionItem) {
        if (collectionItem.progress && collectionItem.progress.end) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].badge
          }, /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              color: '#154988'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Survey has been completed",
            placement: "bottom"
          }, /*#__PURE__*/_react["default"].createElement(_icons.IconComplete, null), " Complete")));
        }
        if (collectionItem.progress && collectionItem.progress.lastVisited) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].badge
          }, /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              color: '#154988'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Survey is in progress",
            placement: "bottom"
          }, /*#__PURE__*/_react["default"].createElement(_icons.IconInProgress, null), " In Progress")));
        }
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, displayOptions.showTags && /*#__PURE__*/_react["default"].createElement(Tags, {
    resource: resource
  }))), renderProgress(), /*#__PURE__*/_react["default"].createElement(Actions, {
    metadata: metadata,
    resource: resource,
    displayOptions: displayOptions,
    externalShareUrl: externalShareUrl,
    collection: collection,
    addToCollection: addToCollection,
    removeFromCollection: removeFromCollection,
    addToCollectionButtonLabel: addToCollectionButtonLabel,
    useFavorite: useFavorite
  }));
}